import Footer from "@/components/footer/footer";
import Header from "@/components/header/header";
import PortalUnavailablePage from "@/components/portal-unavailable-page";
import RootProvider from "@/providers/root-provider";

function App() {
	return (
		<RootProvider>
			<div className="antialiased">
				<div className="sm:sticky sm:top-0 sm:z-50">
					<Header />
				</div>
				<main>
					<PortalUnavailablePage />
				</main>
				<Footer />
			</div>
		</RootProvider>
	);
}

export default App;
